module.exports = __webpack_public_path__ + "static/media/tournaments.443e3799.webp";